import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import useTelegramAuth from "../hooks/useTelegramAuth";

const WEB_PIXEL_ID = "1464244464894234";

const MetaPageView = () => {
  const location = useLocation();
  const { isTelegram } = useTelegramAuth();
  const isInitialized = useRef(false);

  useEffect(() => {
    if (!window.fbq) return;

    if (!isInitialized.current) {
      const pixelId = WEB_PIXEL_ID;

      window.fbq("init", pixelId);
      window.fbq("track", "PageView");

      isInitialized.current = true;
      return;
    }

    window.fbq("track", "PageView");
  }, [location.pathname, isTelegram]);

  return null;
};

export default MetaPageView;
